import { useTranslate } from "@/lib/i18n";

import {
  SERVICE_REQUEST_ICONS,
  SERVICE_REQUEST_LABELS,
  type ServiceRequest,
} from "./serviceRequests";

/**
 * A table's open asks on its floor tile (D132): one badge per ask, its kind's
 * icon and short name. The word is always there — colour and glyph are never
 * the only carriers.
 */
export function ServiceRequestBadges({
  asks,
  testId,
}: {
  asks: readonly ServiceRequest[];
  /** The tile's own test id; each badge appends `-ask-<KIND>`. */
  testId: string;
}) {
  const t = useTranslate();
  if (asks.length === 0) return null;
  return (
    <span data-ui="floor-tile-asks" className="flex flex-wrap gap-1">
      {asks.map((ask) => {
        const Icon = SERVICE_REQUEST_ICONS[ask.kind];
        return (
          <span
            key={ask.id}
            data-ui="floor-tile-badge"
            data-tone="ask"
            data-kind={ask.kind}
            data-testid={`${testId}-ask-${ask.kind}`}
            className="inline-flex items-center gap-1"
          >
            <Icon aria-hidden="true" size={12} strokeWidth={2} />
            {t(SERVICE_REQUEST_LABELS[ask.kind])}
          </span>
        );
      })}
    </span>
  );
}
